import { render, staticRenderFns } from "./distributormanage.vue?vue&type=template&id=dc4ee824&scoped=true"
import script from "./distributormanage.vue?vue&type=script&lang=js"
export * from "./distributormanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ee824",
  null
  
)

export default component.exports